// extracted by mini-css-extract-plugin
export default {"editButton":"ExerciseAdder_editButton__cHUVz","form":"ExerciseAdder_form__tXlTA","h3":"ExerciseAdder_h3__Ki80C"};